// extracted by mini-css-extract-plugin
module.exports = {"body":"ManagerApp_body__CSpsp","main":"ManagerApp_main__E8BxA","content":"ManagerApp_content__oyehJ","yearSwitching":"ManagerApp_yearSwitching__26DXO"};